import React from "react";
import { QuestionBox } from "../shared/QuestionBox";
import { Heading } from "../shared/Heading";
import { useContext } from "../../../../../context";
import { Options } from "../shared/Options";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import styles from "./styles.module.scss";
import { Input } from "../shared/Input";
import { BLOCK_FIELDS } from "../../../../../config";

export const Scale = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey.preview",
  });

  const { blocks, previewAnswers } = useContext();
  const block = blocks.getCurrent();

  return (
    <QuestionBox>
      <Heading
        title={block[BLOCK_FIELDS.question]}
        description={block[BLOCK_FIELDS.description]}
        index={blocks.getCurrentIndex() + 1}
      />
      <Options
        list={["1", "2", "3", "4", "5"]}
        selected={[previewAnswers.get(block.id)]}
        onSelect={(value) => previewAnswers.set(block.id, value)}
      />
      <div className={styles.labels}>
        <span>{t("scale.lowest")}</span>
        <span>{t("scale.highest")}</span>
      </div>
      {block[BLOCK_FIELDS.commentsOnScale] && (
        <Input
          placeholder={t("answerPlaceholder")}
          value={previewAnswers.getComment(block.id) || ""}
          onChange={(value) => previewAnswers.setComment(block.id, value)}
        />
      )}
    </QuestionBox>
  );
};
